<template>
	<transition :name="transitionName">
		<div
			class="ms-popup-main"
			v-show="active"
			v-if="!forceRender || (active && forceRender)"
			tabindex="0"
			@keydown="onKeydown"
			:style="{ 'z-index': posZ }"
			:class="cssPopupMain"
		>
			<div class="semi-blackScreen" v-if="showSemiBlack"></div>
			<slot></slot>
			<msDragable
				ref="dragable"
				:w="widthx"
				:h="heightx"
				:z="posZ"
				:x="posX"
				:y="posY"
				:style="heightDefault"
				:isResizable="false"
				:isDraggable="isDraggable"
				@dragstop="offDraggable"
				class="form-popup"
				:class="{
					'right-to-left': animation == 'right-to-left',
					'left-right-full': animation == 'left-right-full',
				}"
			>
				<slot name="header"></slot>
				<slot name="content" :dataFromParent="dataFromParent"></slot>
			</msDragable>
			<input @focus="focusFirstControl" class="input-invisiabled" />
		</div>
	</transition>
</template>
<script>
import msDragable from '@/components/msdragable/vue-drag-resize.vue';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
export default {
	name: 'MsPopupV2',
	components: {
		msDragable,
	},
	props: {
		dataFromParent: {},
		//Trạng thái đóng mở popup
		active: {
			default: false,
			type: Boolean,
		},
		//Độ rộng của popup
		width: {
			default: 0,
			type: Number,
		},
		//Độ cao của popup
		height: {
			default: 0,
			type: Number,
		},
		//Cấu hình popup hiện thị full màn hình
		fullScreen: {
			default: false,
			type: Boolean,
		},
		cssHeader: {
			default: null,
			type: String,
		},
		cssContent: {
			default: null,
			type: String,
		},
		cssFooter: {
			default: null,
			type: String,
		},
		cssPopup: {
			default: null,
			type: String,
		},
		fixHeight: {
			default: false,
			type: Boolean,
		},
		placement: {
			default: 'center',
			type: String,
		},
		animation: {
			default: null,
			type: String,
		},
		helpPath: {
			default: null,
			type: String,
		},
		iconClose: {
			default: true,
			type: Boolean,
		},
		cssCloseBtn: {
			default: null,
			type: String,
		},
		hasDraggable: {
			default: true,
			type: Boolean,
		},
		defaultCssHeader: {
			default: true,
			type: Boolean,
		},
		defaultCssContent: {
			default: true,
			type: Boolean,
		},
		defaultCssFooter: {
			default: true,
			type: Boolean,
		},
		forceRender: {
			default: false,
			type: Boolean,
		},
		autoFocus: {
			default: true,
			type: Boolean,
		},
		posZ: {
			default: 1100,
			type: Number,
		},
		position: {
			default: null,
		},
		showSemiBlack: {
			default: true,
			type: Boolean,
		},
		cssPopupMain: {
			default: 'ms-popup-main',
			typeof: String,
		},
		transitionName: {
			default: 'fade',
			typeof: String,
		},
		isUsingKeyDown: {
			default: true,
			typeof: Boolean,
		},
		borderRadius: {
			default: true,
			typeof: Boolean,
		},
	},
	//Tính toán lại độ rộng,độ cao,vị trí của popup và đưa element popup ra ngoài body
	created() {
		const me = this;
		me.updateSizePopup();
		window.addEventListener('resize', me.updateSizePopup);
		EventBusGlobal.$on(
			GlobalEventName.closeAllPopup,
			me.closePopupFromInstance
		);
		me.helpId = me.helpPath;
	},
	mounted() {
		document.body.appendChild(this.$el);
		if (this.$refs.content) {
			this.$refs.content.addEventListener('scroll', this.raiseEventScroll);
		}
	},
	data() {
		this.popupItems = {};
		return {
			isDraggable: false,
			widthx: 0,
			heightx: 0,
			posX: 0,
			posY: 0,
		};
	},
	computed: {
		heightDefault() {
			const me = this;
			if (
				me.fullScreen ||
				me.height ||
				me.fixHeight ||
				me.placement != 'center'
			) {
				return null;
			}
			return { height: 'auto' };
		},
	},
	watch: {
		width() {
			this.updateSizePopup();
		},
		height() {
			this.updateSizePopup();
		},
		active: {
			handler(newVal, oldVal) {
				const me = this;
				if (newVal == true) {
					me.$nextTick(() => {
						me.focusFirstControl(me.$el);
						me.updateSizePopup();
					});
				}
			},
		},
		helpPath: {
			handler(newVal, oldVal) {
				const me = this;
				me.helpId = me.helpPath;
			},
		},
	},
	methods: {
		showHelp() {
			const me = this;
			me.$emit('help', me.helpPath);
		},
		focusFirstControl(e) {
			const me = this;
			if (me.autoFocus) {
				me.$ms.commonFunc.focusFirstControl(me.$el);
			} else {
				me.$el.focus();
			}
		},
		raiseEventScroll(e) {
			EventBusGlobal.$emit(GlobalEventName.scrollEvent, e);
		},
		/**
		 * Hàm đóng popup từ bên trong instance cập nhật 2 chiều lại giá trị active
		 */
		closePopupFromInstance(e) {
			const me = this;
			me.$emit('update:active', false);
		},
		/**
		 * Cập nhật lại độ rộng vào độ cao của grid khi kích cỡ màn hình thay đổi
		 * Created by LTDAT 26.06.2020
		 */
		updateSizePopup() {
			let me = this,
				windowWidth = me.getWindowWidth(),
				windowHeight = me.getWindowHeight();
			if (me.posX) {
			}
			if (me.fullScreen) {
				me.widthx = windowWidth;
				me.heightx = windowHeight;
				me.posX = 0;
				me.posY = 0;
			} else if (me.placement == 'right') {
				me.widthx = me.width ? me.width : windowWidth / 2;
				me.heightx = windowHeight;
				me.posX = windowWidth - me.widthx;
				me.posY = 0;
			} else {
				me.widthx = me.width ? me.width : windowWidth / 2;
				me.heightx = me.height ? me.height : windowHeight / 2;
				me.$nextTick(() => {
					if (me.$refs.mspopup) {
						me.posX =
							(windowWidth - (me.$refs.mspopup.offsetWidth || me.widthx)) / 2;
						me.posY =
							(windowHeight - (me.$refs.mspopup.offsetHeight || me.heightx)) /
							2;
					} else {
						me.posX = (windowWidth - me.widthx) / 2;
						me.posY = (windowHeight - me.heightx) / 2;
					}
				});
			}
			if (me.position) {
				if (me.position.hasOwnProperty('posX')) {
					me.posX = me.position.posX;
				}
				if (me.position.hasOwnProperty('posY')) {
					me.posY = me.position.posY;
				}
			}
		},
		/**
		 * Đưa popup về giữa màn hình
		 */
		setMiddlePosition() {
			let me = this,
				windowWidth = me.getWindowWidth(),
				windowHeight = me.getWindowHeight();
			me.$nextTick(() => {
				if (me.$refs.dragable) {
					if (!me.height) {
						me.heightx = me.$refs.dragable.$el.offsetHeight;
						me.posX = (windowWidth - me.widthx) / 2;
						me.posY = (windowHeight - me.heightx) / 2;
					}
				}
			});
		},
		/**
		 * Lấy độ rộng của màn hình
		 * Created by LTDAT 26.06.2020
		 */
		getWindowWidth() {
			let windowWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			return windowWidth;
		},
		/**
		 * Lấy độ cao của màn hình
		 * Created by LTDAT 26.06.2020
		 */
		getWindowHeight() {
			let windowHeight =
				window.innerHeight ||
				document.documentElement.clientHeight ||
				document.body.clientHeight;
			return windowHeight;
		},

		/**
		 * Xử lý sự kiện keydown trên popup
		 * Created by LTDAT 26.06.2020
		 */
		onKeydown(e) {
			const me = this;
			if (e.which == 27 && me.isUsingKeyDown) {
				me.closePopup();
			}
		},
		/**
		 * Sự kiện bắt đầu kéo di chuyển popup
		 */
		onDraggable(event) {
			const me = this;
			if (event && event.target && event.target.closest('.ms-editor')) {
				return;
			}
			if (!me.fullScreen && me.placement == 'center' && me.hasDraggable) {
				me.isDraggable = true;
			}
		},
		/**
		 * Sự kiện thả di chuyển popup
		 */
		offDraggable() {
			const me = this;
			me.$nextTick(() => {
				me.$refs.dragable.active = false;
				me.isDraggable = false;
				const listCbxPopup = [
					'listTitles',
					'listRoles',
					'cbxExportForm1',
					'cbxExportForm2',
					'cbxExportForm3',
					'comboboxSettingOrgDetail',
					'cbxSettingTranferByTaxCode',
					'cbxDowloadInvoiceForm',
				];
				listCbxPopup.forEach((obj) => {
					if (me.$root && me.$root.$refs[obj] && me.$root.$refs[obj].expanded) {
						me.$root.$refs[obj].expand(false);
					}
				});
			});
		},
		//SỰ kiện đóng popup
		closePopup() {
			const me = this;
			let active = false;
			setTimeout(() => {
				me.$emit('close', active);
			}, 100);
		},
	},
	beforeDestroy() {
		const me = this;
		window.removeEventListener('resize', me.updateSizePopup);

		if (this.$refs.content) {
			this.$refs.content.removeEventListener('scroll', me.raiseEventScroll);
		}

		EventBusGlobal.$off(
			GlobalEventName.closeAllPopup,
			me.closePopupFromInstance
		);
	},
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msPopup.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msPopup.scss';
}
</style>